import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme, CssBaseline, Box } from '@mui/material';
import Home from './pages/Home';
import About from './pages/About';
import Projects from './pages/Projects';
import Contact from './pages/Contact';
import Skills from './pages/Skills';  // Import new Skills component
import Experience from './pages/Experience';  // Import new Experience component
import Education from './pages/Education';  // Import new Education component
import Navbar from './components/Navbar';
import Footer from './components/Footer';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2', // Blue for buttons or links
    },
    background: {
      default: '#f5f5f5', // Light grey for the background
    },
    text: {
      primary: '#333333', // Dark grey for text
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        {/* Layout Container */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100vh', // Ensures full screen height
          }}
        >
          <Navbar />
          {/* Main Content */}
          <Box
            component="main"
            sx={{
              flex: '1', // Fills remaining space
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/Skills" element={<Skills />} /> {/* Skills route */}
              <Route path="/Experience" element={<Experience />} /> {/* Experience route */}
              <Route path="/Education" element={<Education />} /> {/* Education route */}
            </Routes>
          </Box>
          {/* Footer */}
          <Footer />
        </Box>
      </Router>
    </ThemeProvider>
  );
}

export default App;
